import { ReticulationDataImportDto } from 'providers/api';

const REQUIRED_KEYS = ['date', 'pipe_data', 'node_data', 'stope_data', 'spool_data'];

type ImportFile = Record<string, unknown>;

export const isReticulationImportFile = (raw: unknown): raw is ImportFile => typeof raw === 'object'
  && raw !== null
  && REQUIRED_KEYS.every((key) => key in raw);

// previous_node may be a list, a single id, or absent. Files with numeric node ids can carry a single id
// of 0, so only null, undefined and an empty string mean "no previous node".
export const normalisePreviousNode = (previousNode: unknown): unknown[] => {
  if (Array.isArray(previousNode)) return previousNode;
  if (previousNode === undefined || previousNode === null || previousNode === '') return [];
  return [previousNode];
};

const normaliseNode = (node: ImportFile): ImportFile => ({
  ...node,
  previous_node: normalisePreviousNode(node.previous_node),
});

// The file is already in the wire format the server binds (the [DataMember] names), so it is sent as it
// is. It must not go through the generated make* mappers: makeNodeId turns a bare id into an object with
// no value, which the server reads as null, and every previous_node link would be dropped on the way.
export const toReticulationImportBody = (raw: ImportFile): ReticulationDataImportDto => ({
  ...raw,
  node_data: Array.isArray(raw.node_data) ? raw.node_data.map(normaliseNode) : raw.node_data,
}) as unknown as ReticulationDataImportDto;
